import { render, staticRenderFns } from "./ReservierungVorbestellungBestaetigen.vue?vue&type=template&id=bc176d32"
import script from "./ReservierungVorbestellungBestaetigen.vue?vue&type=script&lang=ts"
export * from "./ReservierungVorbestellungBestaetigen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports